import React from 'react';
import { Configuration } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { useAuthClient } from './hooks/useAuthClient';
import { DefaultEventHandler, EventHandlers } from './utils/handleEvents';

export type AuthProviderProps = {
  authConfig: Configuration;
  customEvents: EventHandlers<DefaultEventHandler>;
  children: React.ReactNode;
};

const AuthProvider: React.FC<AuthProviderProps> = ({ authConfig, children, customEvents }) => {
  const client = useAuthClient({
    authConfig,
    enableAccountStorageEvents: true,
    eventHandlers: customEvents,
  });

  return <MsalProvider instance={client}>{children}</MsalProvider>;
};

export default AuthProvider;
